<!--
* @Author : ShaJiaJing
* @Date :  2019/10/9
* @Version : 1.0
* @Content : 应用列表
-->
<template>
  <div class="page-wrapper">
    <r-pointer :textName="$t('page.license.list.title')" />
    <!-- 搜索 -->
    <r-search class="p_search" :hasISenior="false" @on-search="commSearch" @on-blur="changeContent">
      <div slot="operation">
        <!-- 创建应用 -->
        <a-button type="primary" @click="$router.push('/application/new')">{{ $t('page.license.list.operation[2]') }}</a-button>
      </div>
    </r-search>
    <!-- 列表数据 -->
    <a-table
      rowKey="id"
      :loading="result.loading"
      :columns="columns"
      :dataSource="result.data"
      :pagination="pagination"
    >
      <div class="securityKey" slot="securityKey" slot-scope="text, record">
        <span v-text="record.showKey ? text : '******'"></span>
        <span class="link" @click="toggleKey(record)">{{ $t(`page.license.list.toggle[${record.showKey ? 1 : 0}]`) }}</span>
      </div>
      <div class="action" slot="operation" slot-scope="record">
        <!-- 删除 -->
        <span @click="delItem(record.id)">
          {{ $t('page.license.list.operation[0]') }}
        </span>
        <!-- 使用详情 -->
        <span @click="$router.push('/finance/details?appKey=' + record.appKey)">
          {{ $t('page.license.list.operation[1]') }}
        </span>
      </div>
    </a-table>
  </div>
</template>

<script>
import { getAppList, deleteApp } from '@api/license'
import { mixinPagination } from '@/utils/mixin'

const defaultConditions = {
  appName: ''
}
export default {
  data () {
    return {
      conditions: JSON.parse(JSON.stringify(defaultConditions)),
      result: {
        loading: false,
        data: []
      },
      columns: [
        {
          title: this.$t('page.license.list.table[0]'),
          label: '应用名',
          dataIndex: 'appName'
        },
        {
          title: this.$t('page.license.list.table[1]'),
          label: 'API Key',
          width: 220,
          dataIndex: 'appKey'
        },
        {
          title: this.$t('page.license.list.table[2]'),
          label: 'SecretKey',
          dataIndex: 'securityKey',
          width: 320,
          scopedSlots: { customRender: 'securityKey' }
        },
        {
          title: this.$t('page.license.list.table[3]'),
          label: '创建时间',
          width: 180,
          dataIndex: 'createTime'
        },
        {
          title: this.$t('private.common.operation'),
          label: '操作',
          key: 'operation',
          align: 'center',
          width: '15%',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  mixins: [mixinPagination],
  computed: {
  },
  created () {
    this.getList()
  },
  methods: {
    delItem (id) {
      this.$confirm({
        title: this.$t('custom.tip.deleteTitle'),
        content: '',
        onOk: () => {
          deleteApp(id).then(res => {
            this.$message.success(this.$t('custom.tip.deleteSuccess'))
            this.getList()
          })
        },
        onCancel: () => {
        }
      })
    },
    getList () {
      Object.assign(this.result, { loading: true })
      const { current: page, pageSize: size } = this.pagination
      getAppList(Object.assign(this.conditions, { page, size })).then(({ total, items }) => {
        console.log(total, items)
        Object.assign(this.result, { data: items })
        Object.assign(this.pagination, { total })
      }).finally(() => {
        Object.assign(this.result, { loading: false })
      })
    },
    changeContent (val) {
      Object.assign(this.conditions, {
        appName: val
      })
    },
    /**
     * 普通搜索
     */
    commSearch (val) {
      this.conditions = Object.assign(JSON.parse(JSON.stringify(defaultConditions)), { appName: val })
      Object.assign(this.pagination, { current: 1 })
      this.getList()
    },
    toggleKey (item) {
      this.$set(item, 'showKey', !item.showKey)
    }
  }
}
</script>

<style lang="less" scoped>
.action{
  span{
    color: #1890ff;
    cursor: pointer;
    transition: color 0.3s;
    &:hover{
      color: #40a9ff;
    }
    & + span{
      &:before{
        content: '';
        display: inline-block;
        height: 12px;
        width: 1px;
        background-color: #e8e8e8;
        margin: 0 8px -1px;
      }
    }
  }
}
.securityKey{
  .link{
    font-size: @font-size-base;
    color: @primary;
    text-decoration: underline;
    cursor: pointer;
    margin-left: 8px;
  }
}
.p_search {
  margin: 9px 0;
}
.ant-row {
  margin-top: 5px;
  width: 100%;
}
</style>
